module.exports = function() {
  return new Worker(__webpack_public_path__ + "f6c21f47a7dea0f759e8.worker.js");
};